// Why profit moved against the matching prior period, in the PRD's six causes.
//
// The causes add up exactly to the change. A month-to-date period is compared
// with the same days of last month, never with all of it.
import React from 'react';

import local from '../ProfitMargin.module.css';
import { EstBadge, MaturityBadge, Money, formatDate } from '../format';

const CAUSES = {
  volume: 'Units sold',
  price: 'Price realised',
  fees: 'Amazon fees',
  cost: 'Cost of goods',
  advertising: 'Advertising',
  returns: 'Returns',
};

const ProfitChange = ({ change }) => {
  if (!change) return null;
  const prior = change.prior_window;

  return (
    <div className={local.card}>
      <div className={local.cardHead}>
        <h2 className={local.cardTitle}>
          Why profit changed <EstBadge show={change.estimated} />
        </h2>
        <span className={local.muted}>
          Against {formatDate(prior?.start)} – {formatDate(prior?.end)}{' '}
          <MaturityBadge maturity={change.prior_maturity} />
        </span>
      </div>

      {!change.available ? (
        <p className={local.note}>{change.reason} There is nothing to compare against yet.</p>
      ) : (
        <>
          <table className={local.subTable} style={{ maxWidth: 520 }}>
            <tbody>
              <tr>
                <td>Net profit then</td>
                <td className={local.numeric}><Money value={change.prior.net_profit} signed /></td>
              </tr>
              {change.causes.map((cause) => (
                <tr key={cause.cause}>
                  <td>{CAUSES[cause.cause] || cause.cause}</td>
                  <td className={local.numeric}>
                    {cause.cause === 'advertising'
                      ? <span className={local.muted}>not connected</span>
                      : <Money value={cause.amount} signed />}
                  </td>
                </tr>
              ))}
              <tr>
                <td><strong>Net profit now</strong></td>
                <td className={local.numeric}>
                  <strong><Money value={change.current.net_profit} signed /></strong>
                </td>
              </tr>
            </tbody>
          </table>
          <p className={local.note}>
            A change of <Money value={change.change} signed />. Units are valued at what
            each unit earned before advertising and returns last period, so the six
            lines add up exactly.
            {change.excluded_skus?.length > 0 && (
              <> {change.excluded_skus.length} SKUs with no cost are left out of both
                periods.</>
            )}
          </p>
        </>
      )}
    </div>
  );
};

export default ProfitChange;
